import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
const Experience = () => {
  return (
    <div>
      <div className="experience ">
        <div className="row experience2  ">
          <div className="experience-heading display-flex-column col-lg-3  ">
            <p className="experience-text-head">EXPERIENCES</p>
            <label className="experience-text">at Surya Vilas Palace</label>
            <div className="experience-logo">
              <img
                className="experience-logo-img"
                src="/Assets/experience-logo.webp"
                alt="group615img"
              ></img>
            </div>
          </div>
          <div className="experience-image-container-main col-lg-9">
            <div className="row">
              <div className="experience-image-container col-4">
                <img
                  className="experience-img"
                  src="/Assets/experience-img1.webp"
                  alt="img"
                ></img>
                <p className="experience-img-text"> DINING</p>
              </div>
              <div className="experience-image-container col-4">
                <img
                  className="experience-img"
                  src="/Assets/experience-img2.webp"
                  alt="img"
                ></img>
                <p className="experience-img-text"> DESTINATION WEDDING </p>
              </div>
              <div className="experience-image-container col-4">
                <img
                  className="experience-img"
                  src="/Assets/experience-img3.webp"
                  alt="img"
                ></img>
                <p className="experience-img-text"> REGIONAL CULTURE</p>
              </div>
            </div>
          </div>
          <div className="experience-swiper">
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 1000, disableOnInteraction: false }}
              loop
              slidesPerView={1}
            >
              <SwiperSlide>
                <div className="experience-image-container">
                  <img
                    className="experience-img"
                    src="/Assets/experience-img1.webp"
                    alt="img"
                  ></img>
                  <p className="experience-img-text"> DINING</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="experience-image-container">
                  <img
                    loading="lazy"
                    className="experience-img"
                    src="/Assets/experience-img2.webp"
                    alt="img"
                  ></img>
                  <p className="experience-img-text"> DESTINATION WEDDING </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="experience-image-container">
                  <img
                    loading="lazy"
                    className="experience-img"
                    src="/Assets/experience-img3.webp"
                    alt="img"
                  ></img>
                  <p className="experience-img-text"> REGIONAL CULTURE</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
